import { useQuery } from 'react-query';

import CMSService from 'App/services/CMSService';

function useFetchContentGroup(uuid) {
    return useQuery(['contentGroup', uuid], () => CMSService.getContentGroup(uuid, { includeContentResource: true }), {
        retry: false,
        refetchInterval: false,
        refetchOnWindowFocus: false,
    });
}

export default useFetchContentGroup;
